module.exports = __webpack_public_path__ + "img/western-sahara.50d03c6f.svg";